module.exports = ['$http', '$q', '$stateParams', function($http, $q, $stateParams) {

    const layoutURL = '/api/ui-interface/v1/layout';
    const fileStorageURL = '/api/ui-interface/v1/diskUsage';
    const dataTransferURL = '/api/ui-interface/v1/dataTransferUsage';

    const userRoles = {editor:"editor", manager:"manager", administrator:"administrator", admin:"admin"};

    let
        editor_layout = [
            { type:"column", colClass:"two-column", children: [
                    { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp", id:"create_content" },
                    { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp", id:"add_assets" }
                ] },
            { type:"column", colClass:"column", children: [
                    { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" }
                ] }
        ],

        editor_layout_shutterstock = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Shutterstock Premiere Images", subtitle:"", component:"shutterstock-image", colClass:"comp comp-left", id:"shutterstock_images" },
                            { type:"component", title:"Shutterstock Premiere Footage/Music", subtitle:"", component:"shutterstock-footage", colClass:"comp comp-right", id:"shutterstock_footage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-left", id:"create_content" },
                            { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-right", id:"add_assets" }
                        ] }
                ] },
            { type:"column", colClass:"column", children: [
                    { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" }
                ] }
        ],

        // drop the publishing at a glance widget
        editor_layout_base = [
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp", id: "create_content" },
                ]
            },
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp", id: "add_assets" }
                ]
            }
        ],

        editor_layout_base_shutterstock = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Shutterstock Premiere Images", subtitle:"", component:"shutterstock-image", colClass:"comp comp-left", id:"shutterstock_images" },
                            { type:"component", title:"Shutterstock Premiere Footage/Music", subtitle:"", component:"shutterstock-footage", colClass:"comp comp-right", id:"shutterstock_footage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-left", id:"create_content" },
                            { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-right", id:"add_assets" }
                        ] }
                ] },
            { type:"column", colClass:"column", children: [
                { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" }
            ] }
        ],



        admin_layout = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Hub usage", subtitle:"", component:"hub-usage", colClass:"comp colspan", id:"hub_usage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Add user", subtitle:"", component:"add-user", colClass:"comp comp-left", id:"add_user" },
                            { type:"component", title:"Update the sample site", subtitle:"Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component:"download-site", colClass:"comp comp-right", id:"download_assets" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-left", id:"create_content" },
                            { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-right", id:"add_assets" }
                        ] }
                ] },
            { type:"column", colClass:"column", children: [
                    { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" }
                ] }
        ],

        admin_layout_shutterstock = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Hub usage", subtitle:"", component:"hub-usage", colClass:"comp colspan", id:"hub_usage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Shutterstock Premiere Images", subtitle:"", component:"shutterstock-image", colClass:"comp comp-left", id:"shutterstock_images" },
                            { type:"component", title:"Shutterstock Premiere Footage/Music", subtitle:"", component:"shutterstock-footage", colClass:"comp comp-right", id:"shutterstock_footage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
	                        { type:"component", title:"Update the sample site", subtitle:"Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component:"download-site", colClass:"comp comp-left", id:"download_assets" },
                            { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-right", id:"add_assets" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
	                        { type:"component", title:"Add user", subtitle:"", component:"add-user", colClass:"comp comp-left", id:"add_user" },
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-right desktop-hidden", id:"create_content_tablet" }
                        ] }
                ] },
            { type:"column", colClass:"column", children: [
                    { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" },
                    { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp tablet-hidden", id:"create_content" }
                ] }

        ],

        // drop the download widget only - this is under toggle for the time being but should eventually
        admin_layout_base_pub_glance = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Hub usage", subtitle:"", component:"hub-usage", colClass:"comp colspan", id:"hub_usage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
	                        { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-left", id:"add_assets" },
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-right", id:"create_content" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
	                        { type:"component", title:"Add user", subtitle:"", component:"add-user", colClass:"comp comp-left", id:"add_user" },
	                        { type:"component", title:"Add user", subtitle:"", component:"add-user", colClass:"comp comp-right always-hidden", id:"add_user_hidden" }
                        ] }
                ] },
            { type:"column", colClass:"column", children: [
                    { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" }
                ] }
        ],

        // drop the download and publishing at a glance widgets
        admin_layout_base = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Hub usage", subtitle:"", component:"hub-usage", colClass:"comp colspan", id:"hub_usage" },
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-left", id:"create_content" },
                            { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-right", id:"add_assets" }
                        ] }
                ] },
            { type:"column", colClass:"column", children: [
                    { type:"component", title:"Add user", subtitle:"", component:"add-user", colClass:"comp", id:"add_user" }
                ] }
        ],

        admin_layout_base_shutterstock = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Hub usage", subtitle:"", component:"hub-usage", colClass:"comp colspan", id:"hub_usage" },
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Shutterstock Premiere Images", subtitle:"", component:"shutterstock-image", colClass:"comp comp-left", id:"shutterstock_images" },
                            { type:"component", title:"Shutterstock Premiere Footage/Music", subtitle:"", component:"shutterstock-footage", colClass:"comp comp-right", id:"shutterstock_footage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-left", id:"create_content" },
                            { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-right", id:"add_assets" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                        { type:"component", title:"Add user", subtitle:"", component:"add-user", colClass:"comp comp-left desktop-hidden", id:"add_user_tablet" },
                        { type:"component", title:"Add user", subtitle:"", component:"add-user", colClass:"comp comp-right always-hidden", id:"add_user_hidden" }
                    ] }
                ] },
            { type:"column", colClass:"column", children: [
	                { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" },
                    { type:"component", title:"Add user", subtitle:"", component:"add-user", colClass:"comp tablet-hidden", id:"add_user" }
                ] }
        ],





        // non-base tier admin view (Add user has been removed as obsolete, keeping here as always hidden for spacing purposes)
        about_layout = [
            {
                type: "column", colClass: "two-column", children: [
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }
                        ]
                    },
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp comp-left desktop-hidden", id: "download_assets_tablet" },
                            { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-left always-hidden", id: "add_user" }
                        ]
                    }
                ]
            },
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp tablet-hidden", id: "download_assets" }
                ]
            }
        ],

        // drop hub usage widget (always hidden here to keep spacing)
        about_layout_non_admin = [
            /*
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp", id: "download_assets" }
                ]
            },
            {
                type: "column", colClass: "two-column", children: [
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan always-hidden", id: "hub_usage" }
                        ]
                    }
                ]
            },
            */
        ],

        // drop the download widget
        about_layout_base = [
            {
                type: "column", colClass: "two-column", children: [
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }
                        ]
                    }
                ]
            },
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp always-hidden", id: "add_user" }
                ]
            }
        ],

        // drop the download widget and hub usage widget, so nothing left
        about_layout_base_non_admin = [
            {
            }
        ],

        // add the SS widgets
        about_layout_shutterstock = [
            {
                type: "column", colClass: "two-column", children: [
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }
                        ]
                    },
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" },
                            { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }
                        ]
                    },
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp comp-left desktop-hidden", id: "download_assets" },
                            { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-right always-hidden", id: "add_user_tablet" }
                        ]
                    }
                ]
            },
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp tablet-hidden", id: "download_assets" }
                ]
            }
        ],

        // add the SS widgets, drop hub usage widget
        about_layout_shutterstock_non_admin = [
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" },
                ]
            },
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }
                ]
            }
            /*
            {
                type: "column", colClass: "two-column", children: [
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" },
                            { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }
                        ]
                    },
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp comp-left desktop-hidden", id: "download_assets" },
                            { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-right always-hidden", id: "add_user_tablet" }
                        ]
                    }
                ]
            },
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp tablet-hidden", id: "download_assets" }
                ]
            }
            */
        ],

        // drop the download widget and add SS widgets (Add User is used as a spacer and never seen)
        about_layout_base_shutterstock = [
            {
                type: "column", colClass: "two-column", children: [
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }
                        ]
                    },
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" },
                            { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }
                        ]
                    }
                ]
            },
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp always-hidden", id: "add_user" }
                ]
            }
        ],

        // drop the download widget, hub usage, and add SS widgets (Add User is used as a spacer and never seen)
        about_layout_base_shutterstock_non_admin = [
            {
                type: "column", colClass: "two-column", children: [
                    {
                        type: "row", rowClass: "two-column-row", children: [
                            { type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" },
                            { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }
                        ]
                    }
                ]
            },
            {
                type: "column", colClass: "column", children: [
                    { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp always-hidden", id: "add_user" }
                ]
            }
        ],


        manager_layout = [
            { type:"column", colClass:"two-column", children: [
                    { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp", id:"create_content" },
                    { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp", id:"add_assets" }
                ] },
            { type:"column", colClass:"column", children: [
                    { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" },
                ] }
        ],

        manager_layout_shutterstock = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Shutterstock Premiere Images", subtitle:"", component:"shutterstock-image", colClass:"comp comp-left", id:"shutterstock_images" },
                            { type:"component", title:"Shutterstock Premiere Footage/Music", subtitle:"", component:"shutterstock-footage", colClass:"comp comp-right", id:"shutterstock_footage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-left", id:"create_content" },
                            { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-right", id:"add_assets" }
                        ] }
                ] },
            { type:"column", colClass:"column", children: [
                    { type:"component", title:"Publishing at a glance", subtitle:"See what has published or is about to publish", component:"publishing-at-a-glance", colClass:"comp rowspan", id:"pub_glance" }
                ] }
        ],

        // drop the publishing at a glance widget
        manager_layout_base = [
            { type:"column", colClass:"two-column-row", children: [
                    { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-left", id:"create_content" },
                    { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-right", id:"add_assets" }
                ] }
        ],

        manager_layout_base_shutterstock = [
            { type:"column", colClass:"two-column", children: [
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Shutterstock Premiere Images", subtitle:"", component:"shutterstock-image", colClass:"comp comp-left", id:"shutterstock_images" },
                            { type:"component", title:"Shutterstock Premiere Footage/Music", subtitle:"", component:"shutterstock-footage", colClass:"comp comp-right", id:"shutterstock_footage" }
                        ] },
                    { type:"row", rowClass:"two-column-row", children: [
                            { type:"component", title:"Upload assets", subtitle:"uploadAssetsSubtitle", component:"add-assets", colClass:"comp comp-left", id:"add_assets" },
                            { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp comp-right desktop-hidden", id:"create_content_tablet" }
                        ] }
                ] },
            { type:"column", colClass:"column", children: [
                { type:"component", title:"Compose content", subtitle:"What are you going to create today?", component:"create-content", colClass:"comp tablet-hidden", id:"create_content" }
            ] }
        ];






    /**
     * Returns a promise to the JSON for the homepage layout for the current tenant user
     * @return {Promise}
     */
    function getTenantUserLayout(tenantUser) {
        return $http({method: 'GET', url: layoutURL}).then(
            (res) => res.data,
            (res) => $q.reject(res.status + ' :: ' + res.statusText)
        );
    }

    /**
     * Returns a promise to the JSON for the current tenant's total disk usage
     * @return {Promise}
     */
    function getTenantDiskUsage() {
        return $http({method: 'GET', url: fileStorageURL}).then(
            (res) => res.data.usageData,
            (res) => $q.reject(res.status + ' :: ' + res.statusText)
        );
    }

    /**
     * Returns a promise to the JSON for the current tenant's total data transfer usage
     * @return {Promise}
     */
    function getTenantDataTransferUsage() {
        return $http.get(dataTransferURL).then(
            (res) => res.data.usageData,
            (res) => $q.reject(res.status + ' :: ' + res.statusText)
        );
    }

    /**
     * Returns the layout based on the user's role and WCH tier
     * @return {Object}
     */
    function getUserLayout(role, tier, showPubGlance, showShutterstockImages, image_level, footage_level, isAboutPageToggleEnabled) {
        let layout = '{}';

        setShutterstockTitles(image_level, footage_level);

        // are we using the new Homepage / About page feature
        if (isAboutPageToggleEnabled === true) {
            // provide the new layouts depending on which page we have navigated to
            const isAboutPage = !!$stateParams.about;
            layout = (isAboutPage === true) ? getAboutPageLayout(role, tier, showShutterstockImages) : getHomepageLayout();
        }
        // no, we are still on the old homepage format
        else {
            switch (role) {
                case userRoles.editor:
                    if (tier !== "base" && showShutterstockImages === true) {
                        layout = editor_layout_shutterstock;
                    }
                    else if (tier !== "base" && showShutterstockImages === false) {
                        layout = editor_layout;
                    }
                    else {
                        if (showPubGlance === true && showShutterstockImages === false) {
                            layout = editor_layout;
                        }
                        else if (showShutterstockImages === true) {
                            layout = editor_layout_base_shutterstock;
                        }
                        else {
                            layout = editor_layout_base;
                        }
                    }
                    break;
                case userRoles.manager:
                    if (tier !== "base" && showShutterstockImages === true) {
                        layout = manager_layout_shutterstock;
                    }
                    else if (tier !== "base" && showShutterstockImages === false) {
                        layout = manager_layout;
                    }
                    else {
                        if (showPubGlance === true && showShutterstockImages === false) {
                            layout = manager_layout;
                        }
                        else if (showShutterstockImages === true) {
                            layout = manager_layout_base_shutterstock;
                        }
                        else {
                            layout = manager_layout_base;
                        }
                    }
                    break;
                case userRoles.admin:
                case userRoles.administrator:
                    if (tier !== "base" && showShutterstockImages === true) {
                        layout = admin_layout_shutterstock;
                    }
                    else if (tier !== "base" && showShutterstockImages === false) {
                        layout = admin_layout;
                    }
                    else {
                        if (showPubGlance === true && showShutterstockImages === false) {
                            layout = admin_layout_base_pub_glance;
                        }
                        else if (showShutterstockImages === true) {
                            layout = admin_layout_base_shutterstock;
                        }
                        else {
                            layout = admin_layout_base;
                        }
                    }
                    break;
                default:
                    break;
            }
        }


        return layout;
    }

    // assume this applies to all roles
    function getHomepageLayout() {
        return editor_layout;
    }

    // assume only Admins can navigate to this page
    function getAboutPageLayout(role, tier, showShutterstockImages) {
        let layout;

        if (tier !== 'base') {
            if (role === 'admin') {
                layout = (showShutterstockImages === true) ? about_layout_shutterstock : about_layout;
            }
            else {
                layout = (showShutterstockImages === true) ? about_layout_shutterstock_non_admin : about_layout_non_admin;
            }
        }
        // base tier
        else {
            if (role === 'admin') {
                layout = (showShutterstockImages === true) ? about_layout_base_shutterstock : about_layout_base;
            }
            else {
                layout = (showShutterstockImages === true) ? about_layout_base_shutterstock_non_admin : about_layout_base_non_admin;
            }
        }

        return layout;
    }

    // Determine the title of Shutterstock widget depending on Shutterstock's user level
    function setShutterstockTitles(image_level, footage_level) {
        let shutterstock_image_level = (image_level === 'premier') ? 'Premiere' : 'Media';
        let shutterstock_footage_level = (footage_level === 'premier') ? 'Premiere' : 'Media';

        let shtterstock_image_title = `Shutterstock ${shutterstock_image_level} Images`;
        let shtterstock_footage_title = `Shutterstock ${shutterstock_footage_level} Footage/Music`;
        editor_layout_shutterstock[0].children[0].children[0].title = shtterstock_image_title;
        editor_layout_shutterstock[0].children[0].children[1].title = shtterstock_footage_title;

        editor_layout_base_shutterstock[0].children[0].children[0].title = shtterstock_image_title;
        editor_layout_base_shutterstock[0].children[0].children[1].title = shtterstock_footage_title;

        admin_layout_shutterstock[0].children[1].children[0].title = shtterstock_image_title;
        admin_layout_shutterstock[0].children[1].children[1].title = shtterstock_footage_title;

        admin_layout_base_shutterstock[0].children[1].children[0].title = shtterstock_image_title;
        admin_layout_base_shutterstock[0].children[1].children[1].title = shtterstock_footage_title;

        manager_layout_shutterstock[0].children[0].children[0].title = shtterstock_image_title;
        manager_layout_shutterstock[0].children[0].children[1].title = shtterstock_footage_title;

        manager_layout_base_shutterstock[0].children[0].children[0].title = shtterstock_image_title;
        manager_layout_base_shutterstock[0].children[0].children[1].title = shtterstock_footage_title;

        about_layout_shutterstock[0].children[1].children[0].title = shtterstock_image_title;
        about_layout_shutterstock[0].children[1].children[1].title = shtterstock_footage_title;

        about_layout_base_shutterstock[0].children[1].children[0].title = shtterstock_image_title;
        about_layout_base_shutterstock[0].children[1].children[1].title = shtterstock_footage_title;
    }


    // return public API for the REST factory
    return {
        getTenantUserLayout: getTenantUserLayout,
        getTenantDiskUsage: getTenantDiskUsage,
        getTenantDataTransferUsage: getTenantDataTransferUsage,
        getUserLayout: getUserLayout
    };
}];


// WEBPACK FOOTER //
// ./app/common/services/homepage-data-service.factory.js